import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import Button from './Button';
import { useTranslation } from 'react-i18next';

export default function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    isLoading = false
}) {
    const { t } = useTranslation();

    const resolvedTitle       = title       ?? t('common.confirm_title',   "O'chirishni tasdiqlaysizmi?");
    const resolvedMessage     = message     ?? t('common.confirm_message',  "Ushbu ma'lumotni o'chirib yubormoqchimisiz? Bu amalni orqaga qaytarib bo'lmaydi.");
    const resolvedConfirmText = confirmText ?? t('common.delete',           "O'chirish");
    const resolvedCancelText  = cancelText  ?? t('common.cancel',           "Bekor qilish");

    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                {/* Backdrop */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                    className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
                />

                {/* Modal content */}
                <motion.div
                    initial={{ scale: 0.95, opacity: 0, y: 20 }}
                    animate={{ scale: 1, opacity: 1, y: 0 }}
                    exit={{ scale: 0.95, opacity: 0, y: 20 }}
                    className="relative w-full max-w-md bg-surface border border-border rounded-2xl shadow-2xl overflow-hidden"
                >
                    <div className="p-6">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
                                <AlertTriangle className="w-6 h-6 text-error" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-xl font-bold text-primary mb-2">{resolvedTitle}</h3>
                                <p className="text-sm text-secondary leading-relaxed">{resolvedMessage}</p>
                            </div>
                            <button
                                onClick={onClose}
                                className="p-1 hover:bg-surface-2 rounded-lg transition-colors text-muted"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>

                        <div className="grid grid-cols-2 gap-3 mt-8">
                            <button
                                onClick={onClose}
                                disabled={isLoading}
                                className="px-5 py-2.5 rounded-xl border border-border text-secondary hover:bg-surface-2 font-bold text-sm transition-colors disabled:opacity-50 whitespace-nowrap"
                            >
                                {resolvedCancelText}
                            </button>
                            <Button
                                onClick={onConfirm}
                                isLoading={isLoading}
                                variant="error"
                                className="px-5 py-2.5 rounded-xl bg-error text-white hover:bg-error-hover font-bold text-sm shadow-lg shadow-error/20 whitespace-nowrap"
                            >
                                {resolvedConfirmText}
                            </Button>
                        </div>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
}
